import Link from 'next/link';

/* eslint-disable-next-line */
type FeaturedCardsWrapperProps = {
  buttonText?: string;
  children: React.ReactNode | React.ReactNodeArray;
  ctaLink: string;
  hasFindMoreButton?: boolean;
  title: string;
};

export function FeaturedCardsWrapper(props: FeaturedCardsWrapperProps) {
  const {
    buttonText,
    children,
    ctaLink,
    hasFindMoreButton = false,
    title
  } = props;

  const buttonLink = hasFindMoreButton ? (
    <Link href={ctaLink} passHref>
      <a className="font-MuseoSans100 font-extralight mt-3 underline">
        {buttonText} &gt;
      </a>
    </Link>
  ) : (
    ''
  );

  return (
    <div className="flex flex-col w-full">
      <p className="font-MuseoSans300 font-bold text-footerGray text-body mb-5">
        {title}
      </p>
      <div className="space-y-4 w-full h-full">{children}</div>
      {buttonLink}
    </div>
  );
}

export default FeaturedCardsWrapper;
